import React, { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  Typography,
  Grid,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormGroup,
  Checkbox,
  OutlinedInput
} from '@mui/material';
import { getFunctionsList, getRegionChannelTeamList, saveUserDetails } from './service';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setBusinessUnit } from '../../../redux/HomePage/cyclesByBuSlice';
import { GENERAL_USER } from '../../../utils/Constants';
import { setIsExistingUserRx } from '../../../redux/General/generalSlice';
import { getUrlWithParams } from '../../../utils/Utils';

export default function EditProfileModal({ userDetails, handleAction }) {
  const [bu, setBU] = React.useState('');
  const [functionOptions, setFunctionOptions] = useState([]);
  const [functionsNewFieldsOptions, setFunctionsNewFieldsOptions] = useState([]);
  const [userFunction, setUserFunction] = useState('');
  const [regionValue, setRegionValue] = useState([]);
  const [channelValue, setChannelValue] = useState([]);
  const [customerValue, setCustomerValue] = useState([]);
  const [showmultiplerows, setShowmultiplerows] = useState(false);
  const otherFunctionCategoryText = '';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getFunctionsData = async (bu) => {
    try {
      let orderedFunction = [];
      const data = await getFunctionsList(bu?.[0]);
      if (data) {
        orderedFunction = data.filter((item) => item !== 'Others').concat('Others');
      }
      setFunctionOptions(orderedFunction || []);
    } catch (error) {
      setFunctionOptions([]);
      console.error('Error getting functions list:', error);
    }
  };

  const getFunctionsNewFieldsData = async (bu, param) => {
    setFunctionsNewFieldsOptions([]);
    try {
      const data = await getRegionChannelTeamList(bu, param);
      setFunctionsNewFieldsOptions(data || []);
    } catch (error) {
      console.error('Error getting functions list:', error);
    }
  };

  const handleFuntionChange = (event) => {
    let functionValue = event.target.value;
    setUserFunction(functionValue);

    let param = {
      criteria: functionValue === 'Customer' ? 'Team' : functionValue
    };
    getFunctionsNewFieldsData(userDetails.BUs.toString(), param);
  };

  const handleCheckboxChange = (functionName, e) => {
    const value = e.target.value;

    if (functionName === 'Region') {
      setRegionValue((prev) => {
        if (prev.includes(value)) {
          return prev.filter((item) => item !== value);
        } else {
          return [...prev, value];
        }
      });
    } else {
      setChannelValue((prev) => {
        if (prev.includes(value)) {
          return prev.filter((item) => item !== value);
        } else {
          return [...prev, value];
        }
      });
    }
  };

  const handleCustomerValueChange = (e) => {
    setCustomerValue(e.target.value);
  };

  const submitUserDetails = async () => {
    let functionFieldsValue = '';

    if (userFunction === 'Customer') {
      functionFieldsValue = customerValue;
    } else if (userFunction === 'Region') {
      functionFieldsValue = regionValue;
    } else if (userFunction === 'Channel') {
      functionFieldsValue = channelValue;
    }

    if (Array.isArray(functionFieldsValue)) {
      functionFieldsValue = functionFieldsValue?.join(',');
    }

    let params = {
      UserEmail: userDetails.email,
      UserRole: userDetails.roles?.toString(),
      UserBusinessUnits: userDetails.BUs?.toString(),
      UserName: userDetails.username,
      UserId: userDetails.gpid,
      MemberFunction: userFunction === 'Other' ? otherFunctionCategoryText : userFunction,
      FunctionValue: functionFieldsValue
    };

    try {
      const res = await saveUserDetails(params, 'edit_modal');
      if (res) {
        dispatch(setIsExistingUserRx(true));
        navigate(getUrlWithParams('/home', bu));
      }
    } catch (error) {
      console.error('Error saving details:', error);
    }
    handleAction(false);
  };

  useEffect(() => {
    if (userDetails.BUs) {
      setBU(userDetails.BUs[0]);
      dispatch(setBusinessUnit(userDetails.BUs[0] || ''));
      getFunctionsData(userDetails.BUs);
    }
  }, [userDetails]);

  return (
    <>
      <Stack
        sx={{ padding: '28px', m: '0px 28px', backgroundColor: '#FBFCFE' }}
        style={{ position: 'relative', left: '135px', top: '70px', width: '654px' }}>
        <Box style={{ marginBottom: '10px' }}>
          <Stack direction="row">
            <Stack direction="column" gap="8px">
              <Typography variant="h4">Edit Profile</Typography>
            </Stack>
          </Stack>
        </Box>

        <Grid container spacing={2}>
          <Grid item sx={{ height: '100%', backgroundColor: '#FBFCFE', p: 2, borderRadius: '8px' }}>
            <Stack direction="column" alignItems="center" gap="6px">
              <Box
                gap="6px"
                sx={{
                  padding: '8px',
                  height: '100%',
                  width: '534px',
                  boxSizing: 'border-box',
                  background: '#FFFFFF',
                  border: '1px solid #DFDFDF',
                  borderRadius: '8px',
                  color: '#616161'
                }}>
                <Stack>
                  <Typography fontWeight={400} sx={{ fontSize: 12, color: '#3A3A3A' }}>
                    User Role
                  </Typography>
                  <Typography sx={{ fontSize: 14 }}>{userDetails.roles}</Typography>
                </Stack>
              </Box>
              <Box
                gap="6px"
                sx={{
                  padding: '8px',
                  height: '100%',
                  width: '534px',
                  boxSizing: 'border-box',
                  background: '#FFFFFF',
                  border: '1px solid #DFDFDF',
                  borderRadius: '8px',
                  color: '#616161'
                }}>
                <Stack>
                  <Typography fontWeight={400} sx={{ fontSize: 12, color: '#3A3A3A' }}>
                    BU
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      wordWrap: 'break-word', // Ensures long text wraps to the next line
                      overflowWrap: 'break-word' // Added for extra support in wrapping long words
                    }}>
                    {userDetails.BUs && userDetails.BUs.length ? userDetails.BUs.toString() : '-'}
                  </Typography>
                </Stack>
              </Box>
              {userDetails.roles && userDetails.roles.includes(GENERAL_USER) && (
                <Box
                  gap="6px"
                  sx={{
                    padding: '8px',
                    height: '100%',
                    width: '567px',
                    position: 'relative',
                    left: '15px',
                    boxSizing: 'border-box',
                    background: '#FFFFFF',
                    border: '1px solid #DFDFDF',
                    borderRadius: '8px',
                    color: '#616161'
                  }}>
                  <Stack>
                    <Typography fontWeight={400} sx={{ fontSize: 12, color: '#3A3A3A' }}>
                      Select Function
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={userFunction}
                        onChange={handleFuntionChange}
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 14
                          },
                          '& .MuiTypography-root': {
                            fontSize: 14
                          }
                        }}>
                        {functionOptions.map((functionName, i) => (
                          <FormControlLabel
                            key={functionName}
                            value={functionName}
                            control={<Radio />}
                            label={functionName}
                          />
                        ))}
                        {userFunction === 'Other' && otherFunctionCategoryText && (
                          <FormControlLabel
                            value={'Other'}
                            control={<Radio />}
                            label={'Other-' + otherFunctionCategoryText}
                          />
                        )}
                      </RadioGroup>
                    </FormControl>
                  </Stack>
                </Box>
              )}
              {userDetails.roles &&
                userDetails.roles.indexOf(GENERAL_USER) != -1 &&
                userFunction == 'Customer' && (
                  <Box
                    gap="6px"
                    sx={{
                      padding: '8px',
                      height: '100%',
                      width: '534px',
                      boxSizing: 'border-box',
                      background: '#FFFFFF',
                      border: '1px solid #DFDFDF',
                      borderRadius: '8px',
                      color: '#616161'
                    }}>
                    <Stack>
                      <Typography
                        fontWeight={400}
                        sx={{
                          fontSize: 12,
                          color: '#3A3A3A'
                        }}>{`Enter ${userFunction}`}</Typography>
                      <OutlinedInput
                        id="customerValue"
                        value={customerValue}
                        name={'customerValue'}
                        placeholder="Input Customer"
                        onChange={(e) => {
                          handleCustomerValueChange(e);
                        }}
                        onMouseLeave={() => {
                          setShowmultiplerows(false);
                        }}
                        inputProps={{
                          maxLength: 50
                        }}
                        onMouseEnter={() => setShowmultiplerows(true)}
                        multiline={showmultiplerows ? true : false}
                        style={{
                          padding: '5px',
                          width: '100%',
                          height: showmultiplerows ? 'auto' : '32px',
                          fontSize: '14px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis'
                        }}
                      />
                    </Stack>
                  </Box>
                )}
              {userDetails.roles &&
                userDetails.roles.indexOf(GENERAL_USER) != -1 &&
                (userFunction == 'Region' || userFunction == 'Channel') && (
                  <Box
                    gap="6px"
                    sx={{
                      padding: '8px',
                      width: '534px',
                      boxSizing: 'border-box',
                      background: '#FFFFFF',
                      border: '1px solid #DFDFDF',
                      borderRadius: '8px',
                      color: '#616161',
                      maxHeight: '6rem',
                      overflowY: 'scroll'
                    }}>
                    <Stack>
                      <Typography
                        fontWeight={400}
                        sx={{
                          fontSize: 12,
                          color: '#3A3A3A'
                        }}>{`Select ${userFunction}s`}</Typography>
                      <FormGroup
                        value={userFunction == 'Region' ? regionValue : channelValue}
                        onChange={(e) => {
                          handleCheckboxChange(userFunction, e);
                        }}
                        row
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 14
                          },
                          '& .MuiTypography-root': {
                            fontSize: 14
                          }
                        }}>
                        {functionsNewFieldsOptions.length
                          ? functionsNewFieldsOptions.map((data, i) => {
                              return (
                                <FormControlLabel
                                  key={data}
                                  control={<Checkbox value={data} />}
                                  label={data}
                                />
                              );
                            })
                          : ''}
                      </FormGroup>
                    </Stack>
                  </Box>
                )}
            </Stack>
            <Box sx={{ textAlign: 'left', mt: 4, ml: 10 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: '204px' }}
                onClick={() => handleAction(false)}>
                Cancel
              </Button>
            </Box>
            <Box sx={{ textAlign: 'right', mt: -4.5, mr: 5 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: '204px' }}
                onClick={submitUserDetails}>
                Save Updates
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
